import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { HierarchicalFolder } from '@/types/hierarchicalFolders';
import { cn } from '@/lib/utils';

interface FolderBreadcrumbProps {
  breadcrumb: HierarchicalFolder[];
  onNavigate: (folderId: string | null) => void;
  className?: string;
}

export function FolderBreadcrumb({ 
  breadcrumb, 
  onNavigate,
  className 
}: FolderBreadcrumbProps) {
  useLanguage();
  return (
    <nav 
      className={cn("flex items-center gap-2 text-sm", className)}
      aria-label={translateInterfaceText("Breadcrumb")}
    >
      {/* Root */}
      <button
        onClick={() => onNavigate(null)}
        className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
      >
        <Home className="h-4 w-4" />
        <span>{translateInterfaceText("Meus vídeos")}</span>
      </button>
      
      <ChevronRight className="h-4 w-4 text-muted-foreground" />
      
      <button
        onClick={() => onNavigate(null)}
        className="text-muted-foreground hover:text-foreground transition-colors"
      >
        {translateInterfaceText("Pastas")}</button>
      
      {/* Folder levels */}
      {breadcrumb.map((folder, index) => (
        <React.Fragment key={folder.id}>
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
          <button
            onClick={() => onNavigate(folder.id)}
            className={cn(
              "hover:text-foreground transition-colors truncate max-w-[200px]",
              index === breadcrumb.length - 1
                ? "font-semibold text-foreground"
                : "text-muted-foreground"
            )}
            aria-current={index === breadcrumb.length - 1 ? "page" : undefined}
          >
            {folder.name}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
}
